export default "__VITE_ASSET__cfac75c9__"